import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { SeguradoraService } from '../services/seguradora.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-seguradora-edit',
  templateUrl: './seguradora-edit.component.html',
  styleUrls: ['./seguradora-edit.component.css'],
	animations: [loadingFade]
})
export class SeguradoraEditComponent implements OnInit {
  public loading;
	public submitting = false;
	public seguradora_id = null;
	public clientes = [];

	public formSeguradora: FormGroup;
	constructor(private route: ActivatedRoute,
		private fb: FormBuilder,
		private authSvc: AuthService,
		private seguradoraSvc: SeguradoraService,
		private router: Router
	) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.seguradora_id = params.id;
				this.seguradoraSvc.getSeguradora(params.id).then((data: any) => {
					this.preencheForm({
						seguradora_id: data.seguradora_id,
						seguradora_nome: data.seguradora_nome,
						seguradora_telefone: data.seguradora_telefone,
						seguradora_email: data.seguradora_email
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formSeguradora = this.fb.group({
			seguradora_id: null,
			seguradora_nome: ['', [Validators.required, Validators.maxLength(100)]],
      seguradora_telefone: null,
      seguradora_email: null
		});
	}

	preencheForm(dados) {
		this.formSeguradora.setValue(dados);
	}

	enviaSeguradora() {
		if (this.formSeguradora.valid) {
			this.submitting = true;

			let toSend = this.formSeguradora.value;
			if (this.seguradora_id === null) { // criar
				this.seguradoraSvc.criaSeguradora(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Seguradora cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/seguradora']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.seguradoraSvc.editaSeguradora(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Seguradora alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/seguradora']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formSeguradora.controls) {
				let campo = this.formSeguradora.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formSeguradora.get(nome);
		return input.touched && input.invalid;
	}
}
